import { render, staticRenderFns } from "./Photovoltaic.vue?vue&type=template&id=6be0458a&scoped=true&"
import script from "./Photovoltaic.vue?vue&type=script&lang=js&"
export * from "./Photovoltaic.vue?vue&type=script&lang=js&"
import style0 from "./Photovoltaic.vue?vue&type=style&index=0&id=6be0458a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be0458a",
  null
  
)

export default component.exports